import { render } from "./PokedexData.vue?vue&type=template&id=5e956a5d&ts=true"
import script from "./PokedexData.vue?vue&type=script&lang=ts"
export * from "./PokedexData.vue?vue&type=script&lang=ts"

import "./PokedexData.vue?vue&type=style&index=0&id=5e956a5d&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])